import { defineMessages } from 'react-intl';

const messages = defineMessages({
  nameAndDescription: {
    id: 'nameAndDescription',
    defaultMessage: 'Name & description',
  },
  product: {
    id: 'product',
    defaultMessage: 'Product',
  },
  status: {
    id: 'status',
    defaultMessage: 'Status',
  },
  lastModified: {
    id: 'lastModified',
    defaultMessage: 'Last modified',
  },
  actions: {
    id: 'actions',
    defaultMessage: 'Actions',
  },
  reviewAndOrder: {
    id: 'reviewAndOrder',
    defaultMessage: 'Review and order',
  },
  export: {
    id: 'export',
    defaultMessage: 'Export',
  },
  noTableData: {
    id: 'noTableData',
    defaultMessage: 'No data to show',
  },
  successDeleteProducts: {
    id: 'successDeleteProducts',
    defaultMessage: 'The selected products were sucessfully deleted',
  },
  errorDeleteProducts: {
    id: 'errorDeleteProducts',
    defaultMessage: 'There was an error deleting the selected products',
  },
  partialErrorDeleteProducts: {
    id: 'partialErrorDeleteProducts',
    defaultMessage: 'There was an error deleting some of the selected products',
  },
  partialSuccessDeleteProducts: {
    id: 'partialSuccessDeleteProducts',
    defaultMessage: 'Some of the selected products were sucessfully deleted',
  },
});

export default messages;
